// removed by extract-text-webpack-plugin
module.exports = {"Header":"SectionHeader__Header__1HkRO","Logo":"SectionHeader__Logo__1nQdw","SectionTitle":"SectionHeader__SectionTitle__2pFV7","SectionSubtitle":"SectionHeader__SectionSubtitle__rJa3I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionHeader/SectionHeader.css
// module id = 194
// module chunks = 0